import { render, staticRenderFns } from "./CreateMailbox.vue?vue&type=template&id=7981d75a&"
import script from "./CreateMailbox.vue?vue&type=script&lang=ts&"
export * from "./CreateMailbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports